import { countries } from 'countries-list';
import type { GpuServerOfferLocation } from '../../../../types/models/GpuServer';

// Tenant-side location helpers for the start wizard. Location codes are opaque: their human name
// comes from the live offer's `locations`, and the country name from `countries-list` (CLAUDE.md
// "Country data").

/** The country's name (`FI` → `Finland`), or the bare code when `countries-list` doesn't know it. */
export function countryName(code: string): string {
  return (countries as Record<string, { name: string } | undefined>)[code]?.name ?? code;
}

/** The offer's location for a code, or `null` when the offer doesn't list it. */
export function findLocation(code: string, locations: GpuServerOfferLocation[]): GpuServerOfferLocation | null {
  return locations.find((location) => location.code === code) ?? null;
}

/** A location's display name (`Finland 1`), falling back to its code. */
export function locationName(code: string, locations: GpuServerOfferLocation[]): string {
  return findLocation(code, locations)?.name ?? code;
}
